// Configure your import map in config/importmap.rb. Read more: https://github.com/rails/importmap-rails
import "@hotwired/turbo-rails"
import "./controllers"
import "trix"
import "@rails/actiontext"
// Rollbar
import Rollbar from 'rollbar';
Rollbar.init({
  accessToken: "ba017c5b44d846d68a49eea7495a5c40",
  captureUncaught: true,
  captureUnhandledRejections: true,
  // Только ошибки, в стеке которых есть наш код. Сторонние скрипты (JSONP
  // Яндекс.Карт, Метрика) падают у ботов и в кэшах — это не наши сбои.
  // Якорь на хост: голое 'vseprokaty.ru' совпало бы с чужим URL, где наш
  // домен лежит в query (Метрика передаёт page-url).
  hostSafeList: ['^https?://([^/]+\\.)?vseprokaty\\.ru/'],
  payload: {
    environment: 'production'
  }
});

import Splide from '@splidejs/splide';
import '@splidejs/splide/dist/css/themes/splide-default.min.css';

// import "mapkick/bundle"

// new Splide('.splide').mount();
if (document.querySelector('.splide')) {
  var splide = new Splide('.splide', {
    lazyLoad: 'nearby',
  });
  splide.mount();
}
